module.exports = __webpack_public_path__ + "static/img/2.70cbb7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.png
// module id = NKGv
// module chunks = 1